/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ConfirmationManager {
  "use strict";

  export class ConfirmationManagerContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.BaseClasses.IDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      trackingService: Meevo.Components.Tracking.ITrackingService) {
      super(appSettings, dataService, modalService, identityService, loggingService, null, trackingService);

     // this.baseEndpoint = appSettings.API_ENDPOINTS.client;
      this.sectionTemplatePath = "app/plugins/confirmationManager/sectionViews/";
    }

    initializeSections(): void {
      this.sections.push(new MainSection(0, "SECTION_SERVICES_MAIN", "main.html", true, false,
        this.appSettings.API_ENDPOINTS.client, "",
        this.loggingService, this.dataService));
    }

    initializeHeader(model:any): void {
      this.headerContent = "Walk-In"; // change later to be dynamic
    }
  }
}